var React = require('react');

function ContactUsIcon (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3.495 5L12 12.655L20.505 5H3.495ZM2 17.586L7.916 11.67L2 6.345V17.585V17.586ZM9.405 13.01L3.415 19H20.585L14.595 13.01L12 15.345L9.405 13.01ZM22 6.345V17.585L16.084 11.67L22 6.345ZM0 6C0 5.20435 0.31607 4.44129 0.87868 3.87868C1.44129 3.31607 2.20435 3 3 3H21C21.7956 3 22.5587 3.31607 23.1213 3.87868C23.6839 4.44129 24 5.20435 24 6V18C24 18.7956 23.6839 19.5587 23.1213 20.1213C22.5587 20.6839 21.7956 21 21 21H3C2.20435 21 1.44129 20.6839 0.87868 20.1213C0.31607 19.5587 0 18.7956 0 18L0 6Z","fill":"#E8EFFF"})));
}

ContactUsIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ContactUsIcon;

ContactUsIcon.default = ContactUsIcon;
